export default __webpack_public_path__ + "static/media/misc-fireplaceA-2048w.14f27512.webp";